import React, { useState } from 'react';
import './BookingForm.css';

const WHATSAPP_NUMBER = '917477471006';
const EMAIL = 'info@bricksnhome.com';

const propertyOptions = [
  'Krishna Vatika – 4BHK Villas',
  'Lotus Greens Villa 2 – 3&4 BHK',
  'Aalayam Srishti Villas – 2&3 BHK',
  'Bollywood Aero City Farms – Farm Estate',
  'Paradise Greens Plaza – Studio/Retail',
  'Other / General Enquiry',
];

const timeSlots = [
  '9:00 AM – 11:00 AM',
  '11:00 AM – 1:00 PM',
  '1:00 PM – 3:00 PM',
  '3:00 PM – 5:00 PM',
  '5:00 PM – 7:00 PM',
];

const purposeOptions = ['Buy', 'Sell', 'Rent / Lease', 'Investment', 'Site Visit'];

export default function BookingForm() {
  const [form, setForm] = useState({
    salutation: 'Mr.',
    name: '',
    mobile: '',
    email: '',
    property: '',
    purpose: '',
    date: '',
    timeSlot: '',
    budget: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handle = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const msg =
      `🏠 *New Appointment Booking — PACompany*\n\n` +
      `👤 *Name:* ${form.salutation} ${form.name}\n` +
      `📱 *Mobile:* ${form.mobile}\n` +
      `📧 *Email:* ${form.email || 'Not provided'}\n` +
      `🏡 *Property Interest:* ${form.property}\n` +
      `🎯 *Purpose:* ${form.purpose}\n` +
      `📅 *Preferred Date:* ${form.date}\n` +
      `⏰ *Time Slot:* ${form.timeSlot}\n` +
      `💰 *Budget:* ${form.budget || 'Not specified'}\n` +
      `💬 *Message:* ${form.message || 'None'}\n\n` +
      `_Sent via PACompany Website_`;

    const encoded = encodeURIComponent(msg);
    const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
    window.open(waUrl, '_blank');
    setSubmitted(true);

    setTimeout(() => setSubmitted(false), 5000);
  };

  const today = new Date().toISOString().split('T')[0];

  return (
    <section className="booking-section">
      <div className="booking-wrapper">

        {/* ── LEFT: FORM ── */}
        <div className="booking-form-side">
          <div className="booking-form-header">
            <div className="booking-icon-wrap">
              <i className="fab fa-whatsapp" />
            </div>
            <div>
              <div className="booking-eyebrow">Book an Appointment</div>
              <h2>Get In Touch With Us</h2>
              <p>Get Real Help From The Best Real Estate Agents in NCR!</p>
            </div>
          </div>

          {submitted ? (
            <div className="booking-success">
              <div className="success-icon"><i className="fab fa-whatsapp" /></div>
              <h3>WhatsApp Opened!</h3>
              <p>Your appointment details have been sent to WhatsApp. Our team will confirm shortly.</p>
              <div className="success-contact">
                <a href={`tel:+${WHATSAPP_NUMBER}`}>
                  <i className="fa fa-phone" /> +91 7477-471-006
                </a>
                <a href={`mailto:${EMAIL}`}>
                  <i className="fa fa-envelope" /> {EMAIL}
                </a>
              </div>
              <button className="booking-btn" onClick={() => setSubmitted(false)}>
                Book Another
              </button>
            </div>
          ) : (
            <form className="booking-form" onSubmit={handleSubmit}>

              {/* Row 1: Salutation + Name */}
              <div className="form-row">
                <div className="form-group sm">
                  <label>Salutation</label>
                  <select name="salutation" value={form.salutation} onChange={handle}>
                    <option>Mr.</option>
                    <option>Mrs.</option>
                    <option>Ms.</option>
                    <option>Dr.</option>
                  </select>
                </div>
                <div className="form-group flex1">
                  <label>Full Name *</label>
                  <input
                    type="text" name="name" placeholder="Your full name"
                    value={form.name} onChange={handle} required
                  />
                </div>
              </div>

              {/* Row 2: Mobile + Email */}
              <div className="form-row">
                <div className="form-group flex1">
                  <label>Mobile Number *</label>
                  <div className="input-icon-wrap">
                    <i className="fa fa-phone" />
                    <input
                      type="tel" name="mobile" placeholder="+91 XXXXX XXXXX"
                      value={form.mobile} onChange={handle} required
                      pattern="[0-9+\s-]{10,15}"
                    />
                  </div>
                </div>
                <div className="form-group flex1">
                  <label>Email Address</label>
                  <div className="input-icon-wrap">
                    <i className="fa fa-envelope" />
                    <input
                      type="email" name="email" placeholder="your@email.com"
                      value={form.email} onChange={handle}
                    />
                  </div>
                </div>
              </div>

              {/* Row 3: Property */}
              <div className="form-group">
                <label>Interested In *</label>
                <div className="input-icon-wrap">
                  <i className="fa fa-home" />
                  <select name="property" value={form.property} onChange={handle} required>
                    <option value="">Select a property...</option>
                    {propertyOptions.map(o => <option key={o}>{o}</option>)}
                  </select>
                </div>
              </div>

              {/* Row 4: Purpose + Budget */}
              <div className="form-row">
                <div className="form-group flex1">
                  <label>Purpose *</label>
                  <select name="purpose" value={form.purpose} onChange={handle} required>
                    <option value="">Select purpose...</option>
                    {purposeOptions.map(o => <option key={o}>{o}</option>)}
                  </select>
                </div>
                <div className="form-group flex1">
                  <label>Budget (Optional)</label>
                  <div className="input-icon-wrap">
                    <i className="fa fa-rupee-sign" />
                    <input
                      type="text" name="budget" placeholder="e.g. ₹50 Lac – ₹1 Cr"
                      value={form.budget} onChange={handle}
                    />
                  </div>
                </div>
              </div>

              {/* Row 5: Date + Time */}
              <div className="form-row">
                <div className="form-group flex1">
                  <label>Preferred Date *</label>
                  <div className="input-icon-wrap">
                    <i className="fa fa-calendar" />
                    <input
                      type="date" name="date"
                      value={form.date} onChange={handle}
                      min={today} required
                    />
                  </div>
                </div>
                <div className="form-group flex1">
                  <label>Preferred Time *</label>
                  <div className="input-icon-wrap">
                    <i className="fa fa-clock" />
                    <select name="timeSlot" value={form.timeSlot} onChange={handle} required>
                      <option value="">Select time slot...</option>
                      {timeSlots.map(t => <option key={t}>{t}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              {/* Message */}
              <div className="form-group">
                <label>Message (Optional)</label>
                <textarea
                  name="message" rows="3"
                  placeholder="Any specific requirements or questions..."
                  value={form.message} onChange={handle}
                />
              </div>

              {/* Submit */}
              <button type="submit" className="booking-btn">
                <i className="fab fa-whatsapp" />
                Send via WhatsApp
              </button>

              <div className="booking-note">
                <i className="fa fa-shield-halved" />
                Your details are secure & will only be shared with our team via WhatsApp.
              </div>
            </form>
          )}
        </div>

        {/* ── RIGHT: MAP + CONTACT ── */}
        <div className="booking-map-side">
          <div className="booking-contact-info">
            <h3>Visit Us or Connect Online</h3>
            <div className="contact-items">
              <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="contact-item wa">
                <div className="ci-icon"><i className="fab fa-whatsapp" /></div>
                <div>
                  <span>WhatsApp Us</span>
                  <strong>+91 7477-471-006</strong>
                </div>
              </a>
              <a href={`mailto:${EMAIL}`} className="contact-item email">
                <div className="ci-icon"><i className="fa fa-envelope" /></div>
                <div>
                  <span>Email Us</span>
                  <strong>{EMAIL}</strong>
                </div>
              </a>
              <div className="contact-item addr">
                <div className="ci-icon"><i className="fa fa-map-marker-alt" /></div>
                <div>
                  <span>Our Office</span>
                  <strong>Sec 16, Chipyana Bujurg, Greater Noida West – 201009</strong>
                </div>
              </div>
              <div className="contact-item time">
                <div className="ci-icon"><i className="fa fa-clock" /></div>
                <div>
                  <span>Working Hours</span>
                  <strong>Mon – Sat: 9 AM – 7 PM</strong>
                </div>
              </div>
            </div>
          </div>

          <div className="booking-map">
            <iframe
              title="Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.5!2d77.4538!3d28.6354!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sGreater%20Noida%20West!5e0!3m2!1sen!2sin!4v1699999999999"
              width="100%" height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            />
          </div>

          {/* WhatsApp floating CTA */}
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Hi! I want to book a property appointment.')}`}
            target="_blank" rel="noreferrer"
            className="wa-float-btn"
          >
            <i className="fab fa-whatsapp" />
            Chat on WhatsApp
          </a>
        </div>

      </div>
    </section>
  );
}
